import { render, staticRenderFns } from "./header.vue?vue&type=template&id=73db08f6&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QToolbarTitle,QItem,QItemSection,QBtnDropdown,QToggle,QDrawer,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn,QToolbarTitle,QItem,QItemSection,QBtnDropdown,QToggle,QDrawer})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
